import FactorUpdateActivity from "./FactorUpdateActivity";
import FactorUpdateActivityPopup from "./FactorUpdateActivityPopup";

export default FactorUpdateActivity;

export { FactorUpdateActivityPopup };
